export const BASE_API_URL = "https://dev.api.mbase2.idc.md";

